import React from 'react';
import { useRouteError } from 'react-router-dom';

// A chunk that 404s is not a crash, it is a stale tab: the deploy that replaced
// the build also replaced every hashed chunk filename. lazyWithRetry reloads
// once on its own; if the page still lands here, say what actually happened
// instead of showing the user a webpack stack trace.
const isStaleBuild = (error) =>
    error?.name === 'ChunkLoadError' ||
    /Loading chunk .* failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(
        error?.message || ''
    );

const AppErrorPage = () => {
    const error = useRouteError();
    const stale = isStaleBuild(error);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-surface-bg p-4">
            <div className="text-center max-w-md">
                <svg
                    className="w-20 h-20 mx-auto mb-6 text-brand-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d={stale
                            ? 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'
                            : 'M12 9v2m0 4h.01M4.062 19h15.876c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L2.33 16c-.77 1.333.192 3 1.732 3z'}
                    />
                </svg>

                <h2 className="text-2xl font-semibold text-content-primary mb-4">
                    {stale ? 'A newer version is available' : 'Something went wrong'}
                </h2>

                <p className="text-content-secondary mb-8">
                    {stale
                        ? 'This tab was open while the app was updated, so part of it could not be loaded. Reloading picks up the new version — nothing you saved is affected.'
                        : 'This page could not be loaded. Reloading usually fixes it; if it keeps happening, please let support know.'}
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={() => { window.location.href = '/'; }}
                        className="px-6 py-2 border border-surface-border rounded-md text-content-primary bg-surface-card hover:bg-surface-bg transition-colors"
                    >
                        Go Home
                    </button>
                    <button
                        onClick={() => window.location.reload()}
                        className="px-6 py-2 rounded-md text-white bg-brand-500 hover:bg-brand-500 transition-colors"
                    >
                        Reload
                    </button>
                </div>

                {!stale && error?.message && (
                    <p className="mt-8 text-xs text-content-tertiary break-words">{error.message}</p>
                )}
            </div>
        </div>
    );
};

export default AppErrorPage;
